import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavigateLinks } from '@/components';
import { icons } from '@/assets';
import { childrenInventoryPageBreadcrumbs } from '../../config';

import style from './Geography.module.css';
export const Geography = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(() => childrenInventoryPageBreadcrumbs(navigate), []);

  return (
    <section className={style.container}>
      <NavigateLinks actualPage='Ubicaciónes' breadcrumbs={breadcrumbs} />
      <ul className={style.modules}>
        <li
          className={style.module}
          onClick={() => navigate('/inventory/geography/offices')}
        >
          <img src={icons.location} alt='Icono de oficinas' />
          <p>Oficinas</p>
        </li>
        <li
          className={style.module}
          onClick={() => navigate('/inventory/geography/cities')}
        >
          <img src={icons.city} alt='Icono de ciudades' />
          <p>Ciudades</p>
        </li>
        <li
          className={style.module}
          onClick={() => navigate('/inventory/geography/departments')}
        >
          <img src={icons.departments} alt='Icono de departamentos' />
          <p>Departamentos</p>
        </li>
      </ul>
    </section>
  );
};
